exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#empresas-container {\n  overflow-y: scroll;\n  height: 600px; }\n\n.save-buttons {\n  text-align: center;\n  padding: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/acopio-detail/acopio-detail.component.scss
// module id = ../../../../../src/app/components/abm/acopio-detail/acopio-detail.component.scss
// module chunks = 0